import Cookie from 'js-cookie'
import loading from '../helpers/loading'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    currentPlatform: null,
    currentUser: !!Cookie.getJSON('authorization'),
    loginError: null,
    token: Cookie.getJSON('authorization')
  },
  mutations: {
    ...loading.mutations,
    reset: state => {
      state.currentPlatform = state.currentUser = state.token = state.loginError = null
    },
    currentUser: (state, { user }) => (state.currentUser = user),
    currentPlatform: (state, { platform }) => (state.currentPlatform = platform),
    loginEnd: (state, token) => (state.token = token),
    loginError: (state, { error }) => (state.loginError = error)
  },
  getters: {
    ...loading.getters,
    currentUser: state => state.currentUser,
    currentPlatform: state => state.currentPlatform,
    connected: state => !!state.token && !!state.currentUser && !!Cookie.getJSON('authorization'),
    needInformations: state => {
      if (state.currentUser && state.currentUser.need_informations) { return true }
      if (state.currentPlatform && state.currentPlatform.need_informations) { return true }
      return false
    },
    token: state => state.token,
    loginError: state => state.loginError
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/session/index.js